import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { ClaudeAiIcon } from './icons/ClaudeAiIcon';
import { AnthropicWhite } from './icons/AnthropicWhite';

export default createWebRegistration({
  icons: {
    ClaudeAiIcon,
    AnthropicWhite,
  },
});
